import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Outfit\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-primary\",\"display\":\"swap\"}],\"variableName\":\"outfit\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-secondary\",\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/oss/app/config/GoogleAnalyticsWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/oss/app/dataStore/ReactQueryProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/oss/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/LoadingSpinner/LoadingSpinner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/LoadingSpinner/LoadingSpinnerContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/app/shared/context/UserContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/styles/globalstyles.scss");
;
import(/* webpackMode: "eager" */ "/app/shared/styles/components.scss");
;
import(/* webpackMode: "eager" */ "/app/shared/styles/routes.scss");
